import styled from 'styled-components';

export const TableControlsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
`;
